import { Middleware } from "redux";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  setIsLoading,
  resetCanvas,
  incrementProgressPercentRandomly,
} from "../features/canvas/canvasSlice";

let progressInterval: NodeJS.Timeout | null = null;

const clearProgressTimer = () => {
  if (progressInterval) {
    clearInterval(progressInterval);
    progressInterval = null;
  }
};

const isSetIsLoadingAction = (
  action: unknown,
): action is PayloadAction<boolean> => {
  return (
    typeof action === "object" &&
    action !== null &&
    "type" in action &&
    (action as { type: string }).type === setIsLoading.type
  );
};

const isResetCanvasAction = (action: unknown): boolean => {
  return (
    typeof action === "object" &&
    action !== null &&
    "type" in action &&
    (action as { type: string }).type === resetCanvas.type
  );
};

const progressTimerMiddleware: Middleware = (store) => (next) => (action) => {
  if (isSetIsLoadingAction(action)) {
    if (action.payload === true) {
      clearProgressTimer();
      progressInterval = setInterval(() => {
        store.dispatch(incrementProgressPercentRandomly({ min: 0, max: 2 }));
      }, 1000);
    } else if (action.payload === false) {
      clearProgressTimer();
    }
  } else if (isResetCanvasAction(action)) {
    clearProgressTimer();
  }

  return next(action);
};

export default progressTimerMiddleware;
